import { Directive, HostBinding, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";

@Directive({
    selector: `
        [modFullWidth],[modFullHeight],
        [modHalfWidth],[modHalfHeight],
        [modOneThirdWidth],[modOneThirdHeight],
        [modTwoThirdWidth],[modTwoThirdHeight],
        [modOneFourthWidth],[modThreeFourthsWidth],
        [modOneFourthHeight],[modThreeFourthsHeight],
    `,
})
export class DimensionModifierDirective {
    @Input() @BooleanAttribute() @HostBinding("class.u-hex-width-full") public modFullWidth: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-hex-height-full") public modFullHeight: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-hex-width-half") public modHalfWidth: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-hex-height-half") public modHalfHeight: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-width-33-percent") public modOneThirdWidth: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-height-33-percent") public modOneThirdHeight: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-width-66-percent") public modTwoThirdWidth: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-height-66-percent") public modTwoThirdHeight: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-width-25-percent") public modOneFourthWidth: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-width-75-percent") public modThreeFourthsWidth: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-height-25-percent") public modOneFourthHeight: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-height-75-percent") public modThreeFourthsHeight: boolean;
}
